import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DadosFranquiaComponent } from './dados-franquia.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: DadosFranquiaComponent}
  ])],
  exports: [RouterModule]
})
export class DadosFranquiaRoutingModule { }
